export default __webpack_public_path__ + "static/media/icono-domicilio-gris.be022c7f.svg";